import React from 'react'
import PropTypes from 'prop-types'
import { Button, BUTTON_SIZES } from '@yoti/ui-kit-components-react/button'

import './SkinnedButton.scss'

const SkinnedButton = ({
  text,
  onClick,
  fullWidth,
  disabled,
  size,
  iconStart
}) => (
  <span className="skinned-button">
    <Button
      onClick={onClick}
      size={size}
      disabled={disabled}
      fullWidth={fullWidth}
      iconStart={iconStart}
    >
      {text}
    </Button>
  </span>
)

SkinnedButton.defaultProps = {
  text: '',
  fullWidth: true,
  iconStart: null,
  disabled: null,
  size: BUTTON_SIZES.LARGE
}

SkinnedButton.propTypes = {
  text: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  fullWidth: PropTypes.bool,
  iconStart: PropTypes.element,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(BUTTON_SIZES)
}

export default SkinnedButton
